import { gql, useQuery } from '@apollo/client'
import { useMemo } from 'react'

import COLORS from 'pared/constants/colors'

export interface IDataType {
  fwWingstopRevenueCenterSales?: {
    options: {
      key: string
      label: string
    }[]
  }
}

interface IMetricDefsDataType {
  uListRequestedLocationMetrics: {
    nodes: { metricCode: string; metricName: string }[]
  }
}

const query = gql`
  query listMetricDefs($iFilter: JSON!) {
    uListRequestedLocationMetrics(iFilter: $iFilter) {
      nodes {
        metricCode
        metricName
      }
    }
  }
`

export const fwWingstopRevenueCenterSalesConfigs = {
  '<%- JSON(fwWingstopRevenueCenterSales?.options) %>': 'price',
} as const

const useRevenueCenterSales = (): IDataType => {
  const { data, loading } = useQuery<IMetricDefsDataType>(query, {
    variables: {
      iFilter: {
        metric_groups: ['Expo Module - Sales By Order Mode'],
      },
    },
  })

  return {
    fwWingstopRevenueCenterSales: useMemo(() => {
      const nodes = data?.uListRequestedLocationMetrics?.nodes || []
      const newData = nodes
        ?.filter((n) => {
          return n.metricCode !== 'sales_total_sales'
        })
        .map((n) => ({
          key: n.metricCode,
          label: n.metricName.replace('sales for ', ''),
        }))
        .sort((a, b) => a.label.localeCompare(b.label))

      return {
        options: [
          ...newData?.map((n, index) => ({
            borderColor: COLORS.STACKED_BAR_COLOR_HUE[index],
            backgroundColor: COLORS.STACKED_BAR_COLOR_HUE[index],
            ...n,
          })),
        ],
      }
    }, [data, loading]),
  }
}

export default useRevenueCenterSales
